@if (questionsLoaded) {
  <div class="hr_collapsible_voting" *ngIf="screenwidth <= 1023">
    <button type="button" class="hr_btn_collapsible" (click)="toggleUVQ()">
      <span
        [ngClass]="{
          active: this.showUVQ == 'in'
        }"
        class="arrow"
      >
        <span></span>
        <span></span>
      </span>
      <span>{{ eLangGlob.translateVoteCollapse }}</span>
    </button>
  </div>
  <div class="hr_collapsed_voting" [@slideInOut]="showUVQ">
    <div
      [ngClass]="{
        margintop: screenwidth <= 1023,
        'hr_voting_box': realBackground || questions?.length <1,
        dateSortItem: listReorderService.sortBy==='date',
        noQuestionsMode: shouldShowNoQuestionsContainer
      }"
    >
      <div id="votingData">
        @if((!noQuestionsVisibleAnimating || isLastItemInAnimation) && eStatus.phase !== 'pre-live' ){
          <div @slideInOut>

          <div
            *ngFor="let q of questions ;trackBy: trackByFn"
            @itemAnimation
            (@itemAnimation.start)="onItemAnimationStart()"
            (@itemAnimation.done)="onItemAnimationDone()"
            class="item"
            [ngClass]="{ alternativeBorder :listReorderService.sortBy==='date' }"
            [id]="q.id"
            [@.disabled]="animationDisabled"
          >
            <lse-user-vote-question-list-item
              [user_vote_questions]="user_vote_questions"
              (myEvent)="handleEvent($event)"
              [question]="q"
            ></lse-user-vote-question-list-item>
          </div>
        </div>
        }

        @if( !isLastItemInAnimation){
          <div @slideInOut>
            @if(questions?.length < 1 || eStatus.phase === 'pre-live' ){
              <div @itemAnimation (@itemAnimation.start)="noQuestionsVisibleAnimating = true" (@itemAnimation.done)="noQuestionsVisibleAnimating = false">
                <div class="uvq_no_questions_container" >
                  <div class="uvq_no_questions" >
                    <div class="opacity_target">
                      <h1 class="uvq_no_questions_gap1">{{ eLangGlob.translateNoUserSeeQuestionsQnA }}</h1>

                        @if(user_vote_questions){
                          @if(didQuestionsExistBefore){
                            <div class="uvq_no_questions_gap2" >{{ eLangGlob.translateNoUserSeeQuestionsSendAdditionalQuestions }} <b>{{ eLangGlob.translateNoUserSeeQuestionsSendAdditionalQuestionsBold }}</b></div>
                          }
                          @else {
                          <div class="uvq_no_questions_gap2" >{{ eLangGlob.translateNoUserVoteQuestionsSendQuestions }}</div>
                          }
                        } @else {
                          <div class="uvq_no_questions_gap2" >{{ eLangGlob.translateNoUserSeeQuestionsSendQuestions }}</div>
                        }


                      @if(user_vote_questions){
                        <div class="uvq_no_questions_gap1 plaintext_thumbsup"></div>
                        <div [innerHTML]="eLangGlob.translateNoUserVoteQuestionsGiveThumbsUp"></div>
                      }

                    </div>
                  </div>

                </div>
              </div>
            }
      </div>
        }

      </div>
    </div>
  </div>
}
<hr *ngIf="screenwidth <= 1023" />
